import { ApplicationSourceEnum } from "@up/data";
import { WebEnvironmentSettings } from '../../../../interfaces/src/lib/web-environment-settings';

export function getAppSource(webEnvironmentSettings: Partial<WebEnvironmentSettings>) {
    const WebApps = {
        [ApplicationSourceEnum.WEB_ORDERING]: webEnvironmentSettings.isWebOrdering ? ApplicationSourceEnum.WEB_ORDERING : null,
        [ApplicationSourceEnum.WEB_ORDERING_WHITELABEL]: webEnvironmentSettings.isWhitelabelApp ? ApplicationSourceEnum.WEB_ORDERING_WHITELABEL : null,
        [ApplicationSourceEnum.WEB_ORDER_AT_TABLE]: webEnvironmentSettings.isOrderAtTable ? ApplicationSourceEnum.WEB_ORDER_AT_TABLE : null,
        [ApplicationSourceEnum.WEB_POS]: webEnvironmentSettings.isPos ? ApplicationSourceEnum.WEB_POS : null,
        [ApplicationSourceEnum.ULTRA_ORDER]: webEnvironmentSettings.isUltraOrder ? ApplicationSourceEnum.ULTRA_ORDER : null,
        [ApplicationSourceEnum.WEB_ORDER_CATERING]: webEnvironmentSettings.isCatering ? ApplicationSourceEnum.WEB_ORDER_CATERING : null
      }
  
      const applicationSourceId = `${
        WebApps[ApplicationSourceEnum.WEB_ORDER_AT_TABLE] ??
        WebApps[ApplicationSourceEnum.WEB_ORDER_CATERING] ??
        WebApps[ApplicationSourceEnum.ULTRA_ORDER] ??
        WebApps[ApplicationSourceEnum.WEB_ORDERING] ??
        WebApps[ApplicationSourceEnum.WEB_ORDERING_WHITELABEL] ??
        WebApps[ApplicationSourceEnum.WEB_POS]
      }`;

      return applicationSourceId;
}
